import React, { useState, useEffect } from "react";
import { NavLink, Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { BRAND, NAV_LINKS } from "../lib/site";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-black/80 backdrop-blur-xl border-b border-[rgba(212,175,55,0.2)]"
          : "bg-black/40 backdrop-blur-md border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between gap-6">
        <Link
          to="/"
          className="flex flex-col leading-none shrink-0"
          data-testid="brand-logo-link"
          onClick={() => setOpen(false)}
        >
          <span className="font-brand text-[26px] md:text-[32px] text-gold leading-none whitespace-nowrap">
            {BRAND.name}
          </span>
          <span className="font-body text-[9px] tracking-[0.35em] text-pink-luxe uppercase mt-1 hidden md:block">
            {BRAND.domain}
          </span>
        </Link>

        <nav className="hidden xl:flex items-center gap-8" data-testid="desktop-nav">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.path}
              to={l.path}
              end={l.path === "/"}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-[12px] tracking-[0.25em] uppercase font-body transition-colors ${
                  isActive ? "text-gold" : "text-white/70 hover:text-gold"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <Link
          to="/consultations"
          className="hidden xl:inline-flex btn-gold whitespace-nowrap"
          data-testid="navbar-cta-consult"
        >
          Reserve
        </Link>

        <button
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="xl:hidden text-gold p-2"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {/* Mobile menu */}
      <div
        className={`xl:hidden overflow-hidden transition-[max-height] duration-500 bg-black/95 border-b border-[rgba(212,175,55,0.2)] ${
          open ? "max-h-[520px]" : "max-h-0"
        }`}
        data-testid="mobile-nav-panel"
      >
        <div className="px-6 py-6 flex flex-col gap-5">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.path}
              to={l.path}
              end={l.path === "/"}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-[14px] tracking-[0.22em] uppercase font-body ${
                  isActive ? "text-gold" : "text-white/80"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/consultations"
            onClick={() => setOpen(false)}
            className="btn-gold mt-2 w-fit"
            data-testid="mobile-cta-consult"
          >
            Book Consultation
          </Link>
        </div>
      </div>
    </header>
  );
}
